export default "__VITE_ASSET__Cylc2YZj__"